import { render, staticRenderFns } from "./Conflict.vue?vue&type=template&id=bcf6d514&"
import script from "./Conflict.vue?vue&type=script&lang=ts&"
export * from "./Conflict.vue?vue&type=script&lang=ts&"
import style0 from "./Conflict.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports